import "./FormStyle.css";
import React, { useState } from 'react';

const Form = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    const text = `Nom: ${name}\nEmail: ${email}\nSujet: ${subject}\nMessage: ${message}`;
    const encodedText = encodeURIComponent(text);
    const phoneNumber = '243897841194'; 
    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodedText}`;

    window.open(whatsappURL, '_blank');
  };

  return (
    <div className="form">
      <form onSubmit={handleSubmit}>
        <label>Your name</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />

        <label>Email</label>
        <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} required />

        <label>Subject</label>
        <input type="text" value={subject} onChange={(e) => setSubject(e.target.value)} required />

        <label>Message</label>
        <textarea
          rows="6"
          placeholder="Type Your message here."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        />

        <button className="btn" type="submit">Submit</button>
      </form>
    </div>
  );
};

export default Form;